export const environment = {
    PRODUCTION: true,
    REGION: 'eu-west-1',
    USER_POOL_ID: 'eu-west-1_vEF2cSkMm',
    USER_POOL_CLIENT_ID: 'lf89c9dffrjdsm92nt17tok0f',
    IDENTITY_POOL_ID: 'eu-west-1:430fe278-28ca-4b00-9725-6bb838995e99',
    COGNITO_LOGIN_ID: 'cognito-idp.eu-west-1.amazonaws.com/eu-west-1_vEF2cSkMm',
    IOT_ADDRESS: 'a2m1kxbqz1ttl-ats.iot.eu-west-1.amazonaws.com',
    API_GATEWAY_INVOKE_URL: 'https://wlyewvkqpa.execute-api.eu-west-1.amazonaws.com/prod'
};



// WEBPACK FOOTER //
// /Users/mjahoo/workspace/rento/git/saunasampo-monitor/src/environments/environment.ts